import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { SVG } from 'components';
import { Button } from 'components/ui';
import { ReactComponent as MoonIcon } from './assets/moon.svg';
import { ReactComponent as SunIcon } from './assets/sun.svg';

export const ThemeToggler = observer(() => {
  const { common } = useStore();

  const handleChangeTheme = () => {
    common.toggleTheme();
  };

  return (
    <Button size={'s'} mode={'neutral'} onClick={handleChangeTheme}>
      <SVG src={common.theme === 'light' ? SunIcon : MoonIcon} />
    </Button>
  );
});
